// src/menu-items/overrides.ts
//
// Routing overrides live in rates-master, next to the rate tables but with
// entirely different mechanics: they take effect on the next call instead of
// travelling through the export queues. Own group, so nobody reaches the
// carrier switch while looking for a price.
import { PhoneOutcome, WarningTriangle } from 'iconoir-react';

const overrides = {
  id: 'overrides-group',
  title: 'Route Overrides',
  type: 'group',
  children: [
    {
      id: 'overrides-numbers',
      title: 'Number Overrides',
      type: 'item',
      url: '/overrides/numbers',
      icon: PhoneOutcome,
      breadcrumbs: true
    },
    {
      id: 'overrides-carriers',
      title: 'Carrier Overrides',
      type: 'item',
      url: '/overrides/carriers',
      icon: WarningTriangle,
      breadcrumbs: true
    }
  ]
};

export default overrides;
